import React from "react";

export const HmsFormContext = React.createContext({});
